var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5C3 10.25 3.21875 10 3.5 10H5.5C5.75 10 6 10.25 6 10.5C6 10.7812 5.75 11 5.5 11H3.5C3.21875 11 3 10.7812 3 10.5ZM7 10.5C7 10.25 7.21875 10 7.5 10H11.5C11.75 10 12 10.25 12 10.5C12 10.7812 11.75 11 11.5 11H7.5C7.21875 11 7 10.7812 7 10.5ZM0 2C0 0.90625 0.875 0 2 0H16C17.0938 0 18 0.90625 18 2V12C18 13.125 17.0938 14 16 14H2C0.875 14 0 13.125 0 12V2ZM1 2V3H17V2C17 1.46875 16.5312 1 16 1H2C1.4375 1 1 1.46875 1 2ZM1 6H17V4H1V6ZM1 7V12C1 12.5625 1.4375 13 2 13H16C16.5312 13 17 12.5625 17 12V7H1Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.f39106a0a1230e4a048f7e3ce23b2cf8.svg";
export { ForwardRef as ReactComponent };